import api from './api';

export interface AdCreative {
  imageUrl: string;
  primaryText: string;
  headline: string;
  articleUrl: string;
}

export interface ComplianceIssue {
  key: string;
  reason: string;
  tip?: string;
  offendingText?: string[];
  where?: string[];
}

export interface AdComplianceResult {
  compliant: boolean;
  issueCount: number;
  issueTypes?: {
    creative?: number;
    article?: number;
  };
  issues?: ComplianceIssue[];
}

export interface ComplianceCheckResponse {
  ads: AdComplianceResult[];
}

class ComplianceService {
  async checkCompliance(ads: AdCreative[]): Promise<ComplianceCheckResponse> {
    const response = await api.post('/v1/akas/compliance/check', { ads });
    return response.data;
  }
}

export default new ComplianceService();
